import { Input } from "antd";
const { TextArea } = Input;
import styles from "../styles/contact.module.css";
import Link from "next/link";
import Meta from "@/comps/Meta";
import { TikTokOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { message } from "antd";

const Contact = () => {

  const [t, i18n] = useTranslation();
  const { language } = i18n;

  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({ name: "", email: "", phone: "", message: "", });

  const handleChange = (field, value) => { setFormData((prev) => ({ ...prev, [field]: value, })); };

  const handleSubmit = async () => {
    if (!formData.email || !formData.message) {
      message.error("Please enter your email and message.");
      return;
    } try {
      setLoading(true);
      const response = await fetch("/api/contact", { method: "POST", headers: { "Content-Type": "application/json", }, body: JSON.stringify(formData), });
      const data = await response.json();
      // if (!response.ok) { throw new Error(data.message); }
      if (!response.ok) {
        throw new Error(data.message || t("Failed to send message."));
      }
      message.success(t("Your message has been sent successfully!"));
      setFormData({ name: "", email: "", phone: "", message: "", });
    }
    catch (error) {
      console.error(error);
      message.error(error.message || t("Something went wrong. Please try again."));
    }
    finally {
      setLoading(false);
    }
  };

  const onChange = (e) => {
    console.log("Change:", e.target.value);
  };

  return (
    <>
      <Meta
        title="Contact Us"
        description="Get in touch with Sigma Machines for inquiries, support, or custom industrial solutions – we're here to help via email, phone, or WhatsApp."
      />

      <div className="bg-[#d9d6400d]" dir={language === "en" ? "ltr" : "rtl"}>
        <div className="px-24 max-xl:px-10">
          <div className="grid grid-cols-3 max-xl:grid-cols-1 gap-4 pt-9 max-xl:pt-1 pb-12">
            <div className="text-lg mt-9 max-xl:mt-3">
              <h3 className="text-[#ffffff] text-2xl font-semibold">
                {t("Sigma Machines")}
              </h3>
              <h3 className="text-[#ffffff] text-xl font-semibold mt-8">
                {t("Office address")}:
              </h3>
              <p className="mt-1 text-[#d9d640]"> {t("Riyadh-Al-Sahafa")}</p>
              <p className="text-[#ffffff]"> {t("distrait-king")}</p>
              <p className="text-[#ffffff]"> {t("Abdulaziz Street")}</p>

              <div className="mt-3">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2863.5590084056057!2d46.81603652586277!3d24.7582337493428!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e2f01da8e490fef%3A0xc8cc0906b5ff5847!2sSigma%20Machines%20Company!5e1!3m2!1sar!2seg!4v1782175761826!5m2!1sar!2seg"
                  width="100%"
                  height="170"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                />
              </div>

              <h3 className="text-[#ffffff] text-xl font-semibold mt-5">
                {t("Warehouse address")}:
              </h3>
              <p className=" text-[#d9d640]"> {t("Riyadh")}</p>
              <p className="text-[#ffffff]"> {t("Al-Sulay Distric")}</p>
              <p className="text-[#ffffff] mb-3"> {t("3969 Al-Jubeir Street")}</p>

              <Link
                href="mailto:info@sigmamachines.net"
                className="mt-8 text-[#d9d640]"
              >
                info@sigmamachines.net
              </Link>
              <h3 >
                <Link
                  href="tel:+966569745955"
                  className="text-[#ffffff] text-2xl font-semibold"
                  dir="ltr"
                >
                  <span className="text-[#d9d640]" >+966</span> 56 974 5955
                </Link>
              </h3>

              <p className="mt-4 text-[#858493]">

                {t("Monday - Friday: 09:00 to 18:00 (GMT +8). Closed on Saturday Sunday.")}
              </p>

              <hr />

              <div className="flex mt-6">
                <Link href="https://www.facebook.com/share/177NhW552u/">
                  <img
                    src="../home/facebook.png"
                    width={30}
                    height={60}
                    className="mr-3"
                    alt="facebook"
                  />
                </Link>
                <Link href="https://www.instagram.com/sigma_machines?igsh=MWRlMmc4OTMyanJwZQ==">
                  <img
                    src="../home/instagram.png"
                    width={30}
                    height={60}
                    className="mr-3"
                    alt="instagram"
                  />
                </Link>

                <Link href="https://www.tiktok.com/@sigma.machines?_t=ZS-8zhbiPLCRDk&_r=1">
                  <TikTokOutlined className="text-3xl mr-3" />
                </Link>
                <Link href="https://www.linkedin.com/company/sigma-machines/">
                  <img
                    src="../home/linkedin.png"
                    width={30}
                    height={60}
                    className="mr-3"
                    alt="linkedin"
                  />
                </Link>
              </div>
              <div className={`${styles.white_circle} mobile_d_none`}></div>
            </div>
            <div className="relative max-xl:mt-9">
              <div className="lg:w-80 lg:ml-auto max-lg:mx-auto">
                <div className={`${styles.half_circle} mobile_d_none`}></div>
                <div className="bg-white p-8 rounded-3xl ml-auto relative z-0">
                  <h3 className="text-[#000000] text-2xl font-semibold">
                    {t("Write")} <span className="text-[#d9d640]">  {t("A Message")}</span>
                  </h3>
                  <div className="mt-8 text-lg">
                    <p className="text-[#a2a2a3]"> {t("Full name")}</p>
                    <Input
                      placeholder={t("Enter your name")}
                      size="large"
                      value={formData.name}
                      onChange={(e) => handleChange("name", e.target.value)}
                      className="rounded-full bg-[#faf9fe] pl-4"
                    />

                    <p className="mt-4 text-[#a2a2a3]">{t("Email")}*</p>
                    <Input
                      placeholder={t("Enter your email")}
                      size="large"
                      value={formData.email}
                      onChange={(e) => handleChange("email", e.target.value)}
                      className="rounded-full bg-[#faf9fe] pl-4"
                    />

                    <p className="mt-4 text-[#a2a2a3]"> {t("Phone")}</p>
                    <Input
                      placeholder="+966"
                      size="large"
                      value={formData.phone} onChange={(e) => handleChange("phone", e.target.value)}
                      className="rounded-full bg-[#faf9fe] pl-4"
                    />

                    <p className="mt-4 text-[#a2a2a3]"> {t("Message")}</p>
                    <TextArea
                      showCount
                      maxLength={100}
                      value={formData.message}
                      onChange={(e) => handleChange("message", e.target.value)}
                      placeholder={t("Write your message here")}
                      style={{
                        height: 100,
                        resize: "none",
                        backgroundColor: "#faf9fe",
                        border: "1px solid #dddddd",
                        // boxShadow: "0 0 2px 1px #dddddd"
                      }}
                      // className="bg-[#faf9fe] pl-4 mb-7"
                      className="bg-[#faf9fe] custom-textarea pl-4 mb-7"
                    />

                    {/* <Link
                      href="mailto:info@sigmamachines.net"
                      className={styles.btn_submit}
                    >
                      {t("Submit Now")}
                    </Link> */}
                    <button type="button"
                      onClick={handleSubmit}
                      disabled={loading}
                      className={styles.btn_submit}>
                      {loading ? "Sending..." : t("Submit Now")}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div>
              {/* <dotlottie-player
                                src="https://lottie.host/a015e608-4c14-4991-aa34-f3deec518440/eINotyliIX.json"
                                background="transparent"
                                speed="1"
                                style={{width: "300px", height: "300px"}}
                                loop
                                autoplay
                            >
                            </dotlottie-player> */}
              <img
                src="../contact/1.png"
                width={550}
                height={250}
                className="mt-20 ml-7 mobile_d_none"
                alt="contact"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Contact;
